import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  fetchStepGuidelineContentAction,
  setStepGuidelineFullViewAction,
} from 'store/aiProcessRuns';

// Opens a citation in the same right-side guideline drawer AI chat uses ("Read Full
// Section"), driven by AI Activity's own guideline-full-view store. The drawer is
// mounted once in ExecutionDetailDrawer, above the run drawer and the review surface.
export const useOpenCitationFullView = () => {
  const dispatch = useDispatch();

  return useCallback(
    citation => {
      dispatch(setStepGuidelineFullViewAction(citation));
      dispatch(
        fetchStepGuidelineContentAction({
          citationId: citation.id,
          sectionId: citation.sectionId ?? null,
          sourceId: citation.sourceId,
          sectionNumber: citation.section,
        }),
      );
    },
    [dispatch],
  );
};
